import { InjectionToken } from '@angular/core'

import { Domain } from 'effector'

export const EFFECTOR_TOKEN = new InjectionToken<Domain>('EffectorDomain')
